import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

@NgModule({
	imports: [RouterModule.forChild([
		{ path: '', data: { breadcrumb : '' }, loadChildren: () =>
			 import('./chamado-empresa-listar/chamado-empresa-listar.module').then(m => m.ChatSuporteEmpresaListarModule) },
		{ path: 'chat', data: { breadcrumb : 'Chat' }, loadChildren: () =>
			 import('./chamado-empresa-chat/chamado-empresa-chat.module').then(m => m.ChamadoEmpresaChatModule) },
		{ path: 'inserir', data: { breadcrumb : 'Novo' }, loadChildren: () =>
			import('./chamado-empresa-inserir/chamado-empresa-inserir.module').then(m => m.ChamadoEmpresaInserirModule) },
		
	])],
	exports: [RouterModule]
})
export class ChamadoEmpresaRoutingModule { }
